<div [formGroup]="form" class="setting-section-container shadow-sm">
  <div class="form-group pt-1 d-flex">
    <div class="align-items-baseline">
      <input
        type="checkbox"
        value=""
        id="automaticSummarizationEnabled"
        formControlName="automaticSummarizationEnabled" />
    </div>
    <div class="col d-block ps-1 pe-0">
      <label for="automaticSummarizationEnabled">
        {{ 'Conversation::AutomaticSummarization:EnableAutomaticAIInsights' | abpLocalization }}
      </label>
      @if (form.get('automaticSummarizationEnabled')?.value) {
        <div class="form-group pt-2">
          <div>
            <input
              formControlName="automaticSummarizationFilterConversations"
              type="radio"
              value="false"
              name="automaticSummarizationFilterConversations"
              id="automaticSummarizationFilterConversations-false" />
            <label class="ps-1" for="automaticSummarizationFilterConversations-false">
              {{ 'Conversation::AutomaticSummarization:ApplyAllConversation' | abpLocalization }}
            </label>
          </div>
        </div>
        <div class="form-group pt-2">
          <div>
            <input
              type="radio"
              name="automaticSummarizationFilterConversations"
              formControlName="automaticSummarizationFilterConversations"
              id="automaticSummarizationFilterConversations-true"
              value="true"
              checked />
            <label class="ps-1" for="automaticSummarizationFilterConversations-true">
              {{
                'Conversation::AutomaticSummarization:FilterConversationByCategory'
                  | abpLocalization
              }}
            </label>
          </div>
        </div>
        <div
          class="form-group pt-2"
          *ngIf="form.get('automaticSummarizationFilterConversations')?.value === 'true'">
          <label for="automaticSummarizationCategories" class="form-label">
            {{ 'CA::Queries' | abpLocalization }}
          </label>
          <ca-category-selector
            [multiple]="true"
            [closeOnSelect]="false"
            placeholder="{{ '::PleaseSelectWithThreeDots' | abpLocalization }}"
            id="automaticSummarizationCategories"
            formControlName="automaticSummarizationCategories"></ca-category-selector>
        </div>
        <div class="form-group pt-2">
          <label for="automaticSummarizationDailyConversationLimit" class="form-label">
            {{
              'Conversation::AutomaticSummarization:DailyAIInsightsConversationLimit'
                | abpLocalization
            }}
          </label>
          <input
            type="number"
            class="form-control form-control-sm"
            id="automaticSummarizationDailyConversationLimit"
            [max]="maxDailyConversationLimit"
            formControlName="automaticSummarizationDailyConversationLimit" />
          <small class="form-text text-muted ms-1">
            0 = {{ 'Conversation::AutomaticSummarization:Unlimited' | abpLocalization }}
          </small>
        </div>
        <div class="form-group pt-2">
          <ca-ai-category-discovery-settings></ca-ai-category-discovery-settings>
        </div>
        <div class="form-group pt-2">
          <ca-ai-coaching-settings></ca-ai-coaching-settings>
        </div>
      }
    </div>
  </div>
</div>
